const getClientToken = () => {
  if (typeof window === "undefined") return null;

  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("token="))
    ?.split("=")[1];
};

export const fetchCartItems = async (tokenFromProps) => {
  let token = tokenFromProps || getClientToken();

  if (!token) return null;

  try {
    const res = await fetch("https://api.marvellife.co/api/v2/purchases/cart", {
      method: "GET",
      headers: {
        "x-auth-token": token,
      },
      cache: "no-store",
    });

    return await res.json();
  } catch (error) {
    return null;
  }
};

export const addCartItem = async ({ productId }) => {
  const token = getClientToken();
  if (!token) return null;

  try {
    const res = await fetch("https://api.marvellife.co/api/v2/purchases/cart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": token,
      },
      body: JSON.stringify({ productId, count: 1 }),
    });

    return await res.json();
  } catch (error) {
    return null;
  }
};

export const removeCartItem = async ({ productId }) => {
  const token = getClientToken();
  if (!token) return null;

  try {
    const res = await fetch("https://api.marvellife.co/api/v2/purchases/cart", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": token,
      },
      body: JSON.stringify({ productId, count: -1 }),
    });

    return await res.json();
  } catch (error) {
    return null;
  }
};
